angular.module('myApp.restaurant', ['ngRoute']).config(['$routeProvider', function($routeProvider) {
	$routeProvider.when('/fatafat/:selectedCity/:category/:id/:namecity', {
		templateUrl: 'components/restaurant/restaurant.html',
		controller: 'restaurantCtrl'
	})

    
}]).controller('restaurantCtrl', ['$scope', '$rootScope', '$window', '$timeout', '$routeParams', 'API', function($scope, $rootScope,
	$window, $timeout, $routeParams, API) {
	

	$window.scrollTo(0, 0);
	var my_id = $routeParams.id;
	var selectedCity = $routeParams.selectedCity;
	var nameCity = $routeParams.namecity;
	 $scope.category = $routeParams.category.toLowerCase();
    $scope.selectedCity = $routeParams.selectedCity;
    $scope.selectedCity = $scope.selectedCity.charAt(0).toUpperCase() + $scope.selectedCity.substr(1).toLowerCase();
	$scope.mainResturantName = $routeParams.namecity;
	$scope.menuList = [];
	$scope.restaurantInfo = [];
	$scope.reviewInfo =[];
	$scope.rotate = false;
	$scope.index = 0;
	$scope.link=""

	
	branch.link({              // for creating deep url

		data: {
			deepindex: 16,
			restaurant_id: my_id,
			'$android_url': 'https://play.google.com/store/apps/details?id=product.clicklabs.jugnoo&amp;hl=en',
			 '$ios_url': 'https://itunes.apple.com/in/app/jugnoo-autos-autos-on-demand/id882391317?mt=8'

		}
	}, function(err, link) {
	   $scope.link=link;
        $scope.$digest();
			
	});
    var restobj = {};
    if($routeParams.category.toLowerCase() == 'meals'){
        restobj = {
            vendor_id: my_id,
            access_token: guestToken,
            longitude: 76.7794179,
            latitude: 30.7333148
        }
    }
    else{
        restobj = {
            restaurant_id: my_id
        }
    }
	
	$scope.getMenusList = function() {
        $rootScope.loading_custom = true;
        API.post(menu_base_url + "website/restaurant_menu",restobj).then(function (result) {


            $scope.restaurantInfo = result.data.restaurant_info;

            if (result.data.restaurant_promos.length) {
                $scope.offer = result.data.restaurant_promos[0];
            }
            $scope.menuList = result.data.restaurant_menu;


            if ($scope.menuList.length && $routeParams.category != 'meals' ) {
                if (!$scope.menuList[0].items) {
                    $scope.selectedCategory = $scope.menuList[0].subcategories;
                }
                else {
                    $scope.selectedCategory = $scope.menuList[0].items;

                }
            }
            else{
                $scope.selectedCategory = $scope.menuList.items;
            }
            var bvTireRating = $scope.restaurantInfo.rating;    // multiply by 20 to get percentage
            var starRating = bvTireRating * 20;                   // set the width of the stars
            $('.star-ratings-top').width(starRating + '%');
            if($scope.restaurantInfo.polygon) {
                $scope.initMap();
                $scope.getCords();
            }

            $timeout(function () {
                var offset = document.getElementById("myScrollspy");
                var fullwidth = document.getElementById("myTab");
                if (fullwidth.offsetWidth < offset.offsetWidth) {
                    $('.rightbutton').css('display', 'none');
                    $('.leftbutton').css('display', 'none');
                    $rootScope.loading_custom = false;
                }
                else {
                    $rootScope.loading_custom = false;
                }
            }, 500);


            (function () {             							// function for appending structued data to the head
                var data = {
                    "@context": "http://schema.org",
                    "@type": "Restaurant",
                    "image": $scope.restaurantInfo.image,
                    "address": {
                        "@type": "PostalAddress",
                        "addressLocality": $scope.restaurantInfo.display_address,
                        "streetAddress": $scope.restaurantInfo.address
                    },
                    "aggregateRating": {
                        "@type": "AggregateRating",
                        "ratingValue": $scope.restaurantInfo.rating,
                        "ratingCount": $scope.restaurantInfo.review_count,
                        "reviewCount": $scope.reviewInfo.length,

                    },
                    "name": $scope.restaurantInfo.name,
                    "priceRange": "100 for 2",
                    "url": "https://www.jugnoo.in/fatafat/" + selectedCity + $routeParams.category + my_id + "/" + nameCity,
                    "servesCuisine": $scope.restaurantInfo.cuisines,
                    "telephone": $scope.restaurantInfo.calling_number,

                }
                var script = document.createElement('script')
                script.type = "application/ld+json";
                script.innerHTML = JSON.stringify(data);
                document.getElementsByTagName('head')[0].appendChild(script);
            })(document);

            (function () {

                var data = {
                    "@context": "http://schema.org",
                    "@type": "BreadcrumbList",
                    "itemListElement": [{
                        "@type": "ListItem",
                        "position": 1,
                        "item": {
                            "@id": "https://jugnoo.in",
                            "name": "Home"
                        }
                    }, {
                        "@type": "ListItem",
                        "position": 2,
                        "item": {
                            "@id": "https://jugnoo.in/fatafat/" + $routeParams.selectedCity,
                            "name": $routeParams.selectedCity
                        }
                    }, {
                        "@type": "ListItem",
                        "position": 3,
                        "item": {
                            "@id": "https://jugnoo.in/fatafat/" + $routeParams.selectedCity + "/" + $routeParams.category,
                            "name": $routeParams.category
                        }
                    }, {
                        "@type": "ListItem",
                        "position": 4,
                        "item": {
                            "name": $scope.restaurantInfo.name
                        }
                    }]
                }


                var script = document.createElement('script')
                script.type = "application/ld+json";
                script.innerHTML = JSON.stringify(data);
                document.getElementsByTagName('head')[0].appendChild(script);
            })(document);


        });
    }



    $scope.getReviewList = function() {
	    $scope.limit = 5;
        API.get(menu_base_url+"website/fetch_feedbacks?restaurant_id=" + my_id)
			.then(function(result) {
			if(result.data.flag == 143)
			{
			
			$scope.reviewInfo = result.data.data.data;
			$scope.ratingMap = result.data.data.rating_map;
			var ratingCount = {1:0, 2:0, 3:0, 4:0, 5:0};
			for(i in $scope.ratingMap)
			{
				ratingCount[i] =  $scope.ratingMap[i].count;
			}
			$scope.totalRatings =  ratingCount[1] + ratingCount[2] + ratingCount[3] + ratingCount[4] + ratingCount[5];



				$scope.onewidth = (ratingCount[1]/$scope.totalRatings)*100;
				$scope.twowidth = (ratingCount[2]/$scope.totalRatings)*100;
				$scope.threewidth = (ratingCount[3]/$scope.totalRatings)*100;
				$scope.fourwidth= (ratingCount[4]/$scope.totalRatings)*100;
				$scope.fivewidth = (ratingCount[5]/$scope.totalRatings)*100;
				
			}
            });
		
	}


	
    $scope.onload = function() {
        $scope.getMenusList();
        $scope.getReviewList();
    }
    $scope.onload();


	
	$scope.selectCategory = function(id, indexValue) {

        $scope.index = indexValue;
		angular.forEach($scope.menuList, function(col) {
			
			if (col.category_id == id) {
				
				if (!col.items) {
					$scope.selectedCategory = col.subcategories
					
				} else {
						$scope.selectedCategory = col.items;
					
				}
			}
		})
		
		var child = $('#myTab').children();
        var elmnt = document.getElementById("calScroll");
        var offset = document.getElementById("myScrollspy");
        var fullwidth = document.getElementById("myTab");
		 var scrollLeftVal = 0;
			var totalWrapper =0;

		 for(li = 0; li < indexValue; li++){
		 	scrollLeftVal+=$(child[li]).width();
		 }
		 scrollLeftVal =  scrollLeftVal - 50;

			$('.wrapper').animate({                         // for sliding the categories
			  scrollLeft: scrollLeftVal
			}, 300);

        if(fullwidth.offsetWidth < offset.offsetWidth) {
            $('.rightbutton').css('display','none ');
            $('.leftbutton').css('display','none ');

        }
        else {

            if(scrollLeftVal <= 0) {
                $('.leftbutton').css("display","none")
            }
            else {
                $('.leftbutton').css("display","block")
            }
            if(scrollLeftVal + offset.offsetWidth >= fullwidth.offsetWidth) {
                $('.rightbutton').css("display","none");
            }
            else
            {
                $('.rightbutton').css("display","block");
            }

        }

    
		
	}




    $scope.scrollLeftWrapper = function() {
        var elmnt = document.getElementById("calScroll");
        var offset = document.getElementById("myScrollspy");
        var fullwidth = document.getElementById("myTab");
        var x = elmnt.scrollLeft - 300;



            $('.wrapper').animate({                         // for sliding the categories
                scrollLeft: x
            }, 300);

        console.log(x);
        if(fullwidth.offsetWidth < offset.offsetWidth) {
            $('.rightbutton').css('display','none ');
            $('.leftbutton').css('display','none ');

        }
        else {
            if (x <= 0) {
                $('.leftbutton').css("display", "none")
            }
            else {
                $('.leftbutton').css("display", "block")
            }
            if (x + offset.offsetWidth >= fullwidth.offsetWidth) {
                $('.rightbutton').css("display", "none");
            }
            else {
                $('.rightbutton').css("display", "block");
            }
        }
    }

    $scope.scrollRightWrapper = function() {
        var elmnt = document.getElementById("calScroll");
        var offset = document.getElementById("myScrollspy");
		var fullwidth = document.getElementById("myTab");
        var x = elmnt.scrollLeft + 300;


        $('.wrapper').animate({                         // for sliding the categories
            scrollLeft: x
        }, 300);

        if(fullwidth.offsetWidth < offset.offsetWidth) {
            $('.rightbutton').css('display','none ');
            $('.leftbutton').css('display','none ');

        }
        else {

            if(x < 0) {

                $('.leftbutton').css("display","none")
            }
            else {
                $('.leftbutton').css("display","block")
            }

            if(x + offset.offsetWidth >=  fullwidth.offsetWidth) {
                $('.rightbutton').css("display","none");
            }
            else
            {
                $('.rightbutton').css("display","block")
            }
		}

    }


	 $(window).on("scroll", function () {
         // for fixing the download app div to the top
            if($(this).scrollTop() >= 189 && $(this).scrollTop() < 480 && ($(window).height() - $(window).scrollTop()) > 330 ) {

                $("#getApp").addClass("stickApp");
                $("#polygon").addClass("stickApp2");
                $("#getApp").css("top", 60);
                $("#polygon").css("top", 250);
                $("#getApp").css("bottom", '');
                $("#polygon").css("bottom", '');
            }

			else if (($(this).scrollTop() >= 480 && ($(window).height() - $(window).scrollTop()) <= 220) || ($(this).scrollTop() >= 189 && $(this).scrollTop() < 480 && ($(window).height() - $(window).scrollTop()) <= 330 ) ) {

                $("#getApp").css("bottom", 500);
                $("#polygon").css("bottom", 250);
                $("#getApp").css("top", '');
                $("#polygon").css("top", '');
			}
            else if ($(this).scrollTop()< 189) {
                console.log("dhkwje")
                $("#getApp").css("bottom", '');
                $("#polygon").css("bottom", '');
                $("#getApp").css("top", '');
                $("#polygon").css("top", '');
                $("#getApp").removeClass("stickApp");
                $("#polygon").removeClass("stickApp2");
            }
     })

	
	
	
	
	
	$scope.olyVeg =function(item) {                     
		if($scope.showVeg == "1" && item.is_veg == "0") {
			return false;
		}
		else{
			return true;
		}
	}








    $scope.showgeoimg = true;


    var all_overlays = [];
    var coordinates_array = [];
    var polygonArray = [];
    var str_coordinates = '';
    var bounds = new google.maps.LatLngBounds();   //defining bounds
    var infoWindow = new google.maps.InfoWindow();   //defining infowindow
    var drawingManager;
    var shape;
    var defaultlat = '';
    var defaultlng = '';

    $scope.disable = 0;

    $scope.show_add_area_btn = 0;
    $scope.show_add_areaname_btn = 0;
    $scope.hideLayer = function () {
        $scope.showgeoimg = false;
    }
    $scope.initMap = function () {
        $scope.map = {
            zoom: 10,
            center: new google.maps.LatLng($scope.restaurantInfo.latitude,$scope.restaurantInfo.longitude),
            pan: true,
            zoomControl: true,
            scaleControl: true,
            fullscreenControl: false
        };

        $scope.mapContainer = new google.maps.Map(document.getElementById('polygonMap'), $scope.map);
        //
        console.log($scope.mapContainer)
        console.log($scope.restaurantInfo.latitude,$scope.restaurantInfo.longitude);

    }

    $scope.getCords = function () {
        var areaList = $scope.restaurantInfo.polygon;
        if(!$scope.restaurantInfo.polygon)
            areaList = [];
        if (areaList.length == 0) {
            $scope.loading = false;
            return false;
        }
        areaList.forEach(function (column) {
            polygonArray = [];
            var polygon = $scope.restaurantInfo.polygon[0];
            console.log("legth"+polygon.length)
            for (var j = 0; j < (polygon.length - 1); j++) {
                //polygon[j] = polygon[j].split(" ");
                polygonArray.push({
                    lat: parseFloat(polygon[j]['x']), lng: parseFloat(polygon[j]['y'])
                });
                var areaBounds = new google.maps.LatLng(parseFloat(polygon[j]['x']), parseFloat(polygon[j]['y']));
                bounds.extend(areaBounds);

            }
            var vendorLatLng = new google.maps.LatLng($scope.restaurantInfo.latitude,$scope.restaurantInfo.longitude)
            bounds.extend(vendorLatLng);
            $scope.loading = false;
            shape = new google.maps.Polygon({
                paths: polygonArray,
                map: $scope.mapContainer,
                strokeColor: 'rgba(130, 201, 253, 0.3)',
                strokeOpacity: 0.8,
                strokeWeight: 1,
                fillColor: 'rgba(130, 201, 253, 0.3)',
                fillOpacity: 0.7
            });

            //
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng($scope.restaurantInfo.latitude,$scope.restaurantInfo.longitude),
                map: $scope.mapContainer,
                icon: '/images/markerImage.png'
            });
            console.log(marker);
            shape.setMap($scope.mapContainer);
            $timeout(function(){
                google.maps.event.trigger($scope.mapContainer, 'resize')
                $scope.mapContainer.fitBounds(bounds);
                marker.setMap($scope.mapContainer);
            })

            //$scope.mapContainer.setCenter(new google.maps.LatLng(polygonArray[0].lat,polygonArray[0].lng));
            //defaultlat = polygonArray[0].lat;
            //defaultlng = polygonArray[0].lng;

        })
    };


}]);